/**
 * practiceCurriculum.json and letterSoundsCurriculum.json are now stored on S3 in aqua-extended bucket. direct link
 * to picky goblins curriculum folder:
 * https://s3.console.aws.amazon.com/s3/buckets/aqua-extended/gc/picky_goblins/curriculum/?region=us-west-2&tab=overview
 *
 * This file is to store the curriculum when it is fetched and offer hooks to retreived the fetched curriculum when needed.
 *
 * Current Curriculums are generated in the Piucky / Grumpy Goblins Content Spreadsheet in two different pages, link to workbook:
 * https://docs.google.com/spreadsheets/d/1Cyq1VVksh9c53eItRwDuhyA_WMzizZqAM6QKdvIf-bo/edit#gid=712797320
 *
 * "TEST Picky Goblins Content": generates practiceCurriculum.json
 * "TEST letter sounds": generates the letterSoundsCurriculum.json
 */
let practiceCurriculum = {};
let letterSoundsCurriculum = {};
let curriculum = {};

export const getCurriculum = () => curriculum;
export const setCurriculum = (newCurriculum) => {
  curriculum = newCurriculum;
};

export const getPracticeCurriculum = () => practiceCurriculum;
export const setPracticeCurriculum = (newPracticeCurriculum) => { practiceCurriculum = newPracticeCurriculum; };

export const getLetterSoundsCurriculum = () => letterSoundsCurriculum;
export const setLetterSoundsCurriculum = (newLetterSoundsCurriculum) => {
  letterSoundsCurriculum = newLetterSoundsCurriculum;
};
